/**
 * altenew.js: Altenew's own storefront JavaScript (this was assets/custom.js).
 * None of it comes from Impulse; stock theme.js lives in theme-v1.0.1.js and
 * only that file needs merging when Impulse is updated. Loaded deferred from
 * layout/theme.liquid on every page.
 */
/* =========================================================================
   08062026-002  Product-card CTA lock

   Measured on /collections/inks: POST /cart/add.js takes 1.3-1.9s on this
   store, and nothing on the card changed while it was in flight — same label,
   same pointer cursor, still clickable. Three clicks 120ms apart therefore
   sent three separate adds and left quantity 3 in the cart, and each queued
   add ran slower than the one before it (1.26s, 1.92s, 1.89s).

   So the first click on any card CTA takes a page-wide lock and turns the
   cursor to progress; every click after it is swallowed in the capture phase,
   before jQuery's delegated add-to-cart handler, Searchanise's own handler or
   the card link can see it.

   The lock releases when the add-to-cart request settles, when any other add
   reports success, or on the fallback timer. A CTA that navigates away holds
   the lock until the page unloads — that is the point, the cursor should stay
   busy while the browser loads the next page — and pageshow clears it on the
   way back from bfcache.

   Notify Me / Join Waitlist are deliberately NOT locked: they open a Klaviyo
   modal rather than starting a cart or navigation, so there is nothing to
   wait for and locking would just freeze the grid behind the modal. The
   wishlist heart is not locked here either — it has its own lock further down.
   ========================================================================= */
var AltenewCardCTA = (function () {
    var LOCK = 'card-cta-busy';

    // A CTA only counts if it sits inside a product card, so the same classes
    // on a PDP or in the cart drawer are left alone.
    var CARD_SEL = '.grid-product, li.snize-product';
    var CTA_SEL = [
        '.hc-form .btn',          // Add To Bag / Buy Now / Sold Out / Pre-Order
        '.view-options-jm .btn',  // View Options / Register / OUT OF STOCK
        '.hc-subscribe-redirect', // More info / sneak peek / free class
        '.snize-button'           // Searchanise results
    ].join(',');

    // Only ever reached by a CTA that navigates (nothing released the lock
    // because the page was supposed to be gone). Same 10s the Buy Now
    // interceptor uses for the same reason.
    var FALLBACK_MS = 10000;

    var timer = null;
    var locked = null;

    // How many add-to-cart requests this file started and is still waiting on.
    // Rebuy fires rebuy:cart.change optimistically, ~150ms into a POST that
    // takes 1.3s, so the external release listeners below have to stand down
    // while one of our own requests is still running — otherwise the lock lets
    // go mid-add and the next click adds the item a second time.
    var pending = 0;

    if (!document.getElementById('card-cta-lock-styles')) {
        var style = document.createElement('style');
        style.id = 'card-cta-lock-styles';
        // The cursor goes on the card as well as the button: the button's own
        // :hover rule would otherwise win over an inherited value, and the card
        // covers the gaps around it.
        style.innerHTML =
            'body.' + LOCK + ' .grid-product,' +
            'body.' + LOCK + ' .grid-product a,' +
            'body.' + LOCK + ' .grid-product .btn,' +
            'body.' + LOCK + ' li.snize-product,' +
            'body.' + LOCK + ' li.snize-product a,' +
            'body.' + LOCK + ' li.snize-product .snize-button' +
            '{cursor:progress!important}';
        document.head.appendChild(style);
    }

    function lock(cta) {
        locked = cta || null;
        // aria-disabled rather than the disabled property: disabled would grey
        // the button out for the whole 1.3s add, and the capture handler below
        // already stops the click.
        if (locked) { locked.setAttribute('aria-disabled', 'true'); }
        document.body.classList.add(LOCK);
        clearTimeout(timer);
        timer = setTimeout(release, FALLBACK_MS);
    }

    function release() {
        clearTimeout(timer);
        timer = null;
        if (locked) {
            locked.removeAttribute('aria-disabled');
            locked = null;
        }
        document.body.classList.remove(LOCK);
    }

    // Called around an add-to-cart this file owns, so release() can tell our
    // own in-flight request from a cart event raised by someone else.
    function hold() {
        pending++;
    }

    function settle() {
        pending = Math.max(0, pending - 1);
        if (pending === 0) { release(); }
    }

    function releaseIfIdle() {
        if (pending === 0) { release(); }
    }

    document.addEventListener('click', function (e) {
        // This runs on every click on the page, so never let it throw: a
        // programmatic dispatch can put a non-Element in e.target, and a
        // TypeError here would kill the click for every other handler.
        if (!e.target || !e.target.closest) return;

        var cta = e.target.closest(CTA_SEL);
        if (!cta || !cta.closest(CARD_SEL)) return;

        if (document.body.classList.contains(LOCK)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return;
        }
        lock(cta);
    }, true);

    // Releases for adds we did not fire ourselves — Searchanise owns the
    // add-to-cart on its own in-stock results and gives us no callback, so
    // these cart events are the only completion signal available there. Both
    // stand down while one of our own requests is in flight.
    document.addEventListener('ajaxProduct:added', releaseIfIdle);
    document.addEventListener('rebuy:cart.change', releaseIfIdle);

    // Coming back via history: the lock was taken by a CTA that navigated away.
    window.addEventListener('pageshow', function () {
        pending = 0;
        release();
    });

    return { lock: lock, release: release, hold: hold, settle: settle };
})();

/* ==========================================================================
   Native cart drawer auto-open on add-to-cart
   Registered early (before jQuery) so a later $ error cannot skip it.
   ========================================================================== */
(function () {
  function openCartDrawerWithRetry(attempt) {
    attempt = attempt || 0;
    if (typeof theme !== 'undefined' && typeof theme.openCartDrawer === 'function') {
      try { theme.openCartDrawer(); return; } catch (e) {}
    }
    var cart = window.__themeCartDrawer;
    if (cart && typeof cart.open === 'function') {
      try {
        if (cart.cartForm && typeof cart.cartForm.buildCart === 'function') {
          cart.cartForm.buildCart();
        }
        cart.open();
        return;
      } catch (e) {}
    }
    if (attempt < 30) {
      setTimeout(function () { openCartDrawerWithRetry(attempt + 1); }, 100);
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function onCartItemAdded() {
    setTimeout(function () { openCartDrawerWithRetry(0); }, 0);
  }

  document.addEventListener('product-form:cart:navigate', function (event) {
    if (window.theme && theme.settings && theme.settings.cartType !== 'page') {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('ajaxProduct:added', onCartItemAdded);
  document.addEventListener('product-form:submit:success', onCartItemAdded);
})();

// The Wishlist Engine app (wishlist-engine-app.js, served from Shopify's
// app-extension CDN) prints a count beside "Add to Wishlist", and the value
// is not reliable: it stamps a "(0)" placeholder into every mount up front,
// then re-renders once /product-status answers — sometimes stringifying its
// own product object into the total, which reads as "([object Object])".
//
// The count is therefore hidden by default, by
// `.wishlist-count:not([data-count-vetted])` in altenew.css. A stylesheet
// in <head> settles before the app can write anything, so the bad text
// never paints — which also spares the buy row the reflow it used to do,
// where an [object Object]-wide label pushed the wishlist onto its own
// line and then snapped back once this code ran.
//
// This pass opts the good values back in rather than hiding the bad ones
// after the fact: a real total over 50 gets data-count-vetted (and the
// tooltip explaining what the number means), anything else stays hidden,
// and non-numeric values are dropped outright so they cannot be read out
// to a screen reader. No colour is set here — .wishlist-engine
// .wishlist-count in altenew.css already gilds it with !important.
//
// The app RE-RENDERS on add/remove, so this watches the document rather
// than running once: observing a single mount missed PDPs (a hidden
// .wishlist-engine precedes the visible button) and a one-shot timeout
// missed every click later than a few seconds in. Renders are batched
// through paceDomPatch(), so a burst of app mutations costs one pass. Masks the symptom only — the real fix belongs in the app.
//
// It sits at the top level of this file rather than in the window-load
// handler with the rest: altenew.js is deferred, so this starts watching as
// soon as the document is parsed — about when the app first paints — rather
// than after every image on the page has finished loading. It uses no
// jQuery, so it has nothing to wait for.
//
// Pacing for the page-wide patch observers below (this one and the wishlist
// role, Re:amaze inert and Flickity tabindex passes). Each re-scans the whole
// document, and while the apps inject during load something changes in nearly
// every frame, so "once per frame" meant dozens of full scans a second: ~1.8s
// of main-thread time on a throttled phone on /collections/inks, holding the
// cookie banner back with everything else (profiled 10/23/2026). This runs a
// pass at most every 400ms until the page has loaded, then every 150ms, always
// on the trailing edge so the last change is never missed. setTimeout, not
// requestAnimationFrame: rAF is suspended in a background tab, which would
// latch the timer and stop the patch for good.
function paceDomPatch(apply) {
    var timer = null;
    var last = 0;
    return function schedule() {
        if (timer) return;
        var gap = document.readyState === 'complete' ? 150 : 400;
        timer = window.setTimeout(function () {
            timer = null;
            last = Date.now();
            apply();
        }, Math.max(0, last + gap - Date.now()));
    };
}

(function sanitizeWishlistCount() {
    function vet(el) {
        var total = parseInt(el.getAttribute('data-total'), 10);
        if (isNaN(total)) {
            el.remove();
        } else if (total > 50) {
            el.setAttribute('title', 'Number of times this product has been added to wishlist.');
            el.setAttribute('data-count-vetted', '');
        } else {
            el.removeAttribute('data-count-vetted');
        }
    }

    // Vets only the counts the app just wrote, straight from the mutation
    // records rather than through paceDomPatch(). The app re-renders the PDP
    // heart on every variant change, and a paced pass left the new count
    // hidden for up to 150ms: the wishlist narrowed and Add to Bag stretched
    // ~37px into the gap, then snapped back (Nicole, 10/26/2026 testing sheet).
    // Observer callbacks run before the next paint, so the count never shows
    // as unvetted. Looking at added nodes only keeps it cheap.
    function onMutations(records) {
        records.forEach(function (record) {
            if (record.type === 'attributes') {
                if (record.target.classList.contains('wishlist-count')) vet(record.target);
                return;
            }
            record.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.classList.contains('wishlist-count')) vet(node);
                node.querySelectorAll('.wishlist-count').forEach(vet);
            });
        });
    }

    // attributeFilter keeps our own title/data-count-vetted writes from
    // re-triggering this; el.remove() is a childList change with nothing added.
    new MutationObserver(onMutations).observe(document.documentElement, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['data-total']
    });

    document.querySelectorAll('.wishlist-count').forEach(vet); // anything already on the page
})();

// The same app renders every wishlist heart into a plain
// <div class="wishlist-engine">, sets aria-label on that div and binds its
// click handler to it. A div has no role, so screen readers drop the label
// and announce nothing, and it never takes keyboard focus (audit V3).
//
// Once the app has hydrated a mount (it has an aria-label), this gives the
// div a button role and puts it in the Tab order. Waiting for the label
// matters: with preferences consent withheld the app never loads, and an
// empty tabbable button would be worse than no button. Enter and Space are
// routed to the app's own click handler.
//
// No aria-pressed: the app's data-added did not flip back to "false" after a
// remove when tested on 09/15/2026, so mirroring it could announce the wrong
// state. The app's own label ("Add to Wishlist" / "Added to Wishlist")
// carries the state instead. Masks the symptom only — a real <button>
// belongs in the app.
(function wishlistButtonRole() {
    function apply() {
        document.querySelectorAll('.wishlist-engine[aria-label]:not([role])').forEach(function (el) {
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
        });
    }

    // attributeFilter leaves out our own role/tabindex writes.
    new MutationObserver(paceDomPatch(apply)).observe(document.documentElement, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['aria-label']
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var el = e.target;
        if (!el.matches || !el.matches('.wishlist-engine[role="button"]')) return;
        e.preventDefault(); // Space would otherwise scroll the page
        el.click();
    });

    apply();
})();

// Mirrors a few open/shown states onto classes on <html>, so CSS can read them
// without html:has(...). An html:has() rule makes every DOM change anywhere on
// the page re-check the style of every element: on the phone homepage that was
// 11s of style work per load and taps waiting 240-430ms for an answer, the main
// cause of Clarity's dead clicks (10/21/2026). Each source element is watched on
// its own attributes only, which costs nothing while it sits still.
(function mirrorStatesToHtml() {
    var STATES = [
        // [class on <html>, elements to watch, true when any of them matches]
        ['cart-drawer-open', '#CartDrawer', '.drawer--is-open'],
        ['cart-drawer-transitioning', '#CartDrawer', '.is-transitioning'],
        ['cg-lightbox-open', '.cg-lightbox', '.is-open'],
        ['class-sticky-shown', '.class-sticky', ':not([hidden])'],
        ['product-sticky-bottom-shown', '.product-sticky-header--bottom', '.fixed:not(.hide)']
    ];
    var root = document.documentElement;

    function sync(state) {
        var on = Array.prototype.some.call(document.querySelectorAll(state[1]), function (el) {
            return el.matches(state[2]);
        });
        if (root.classList.contains(state[0]) !== on) root.classList.toggle(state[0], on);
    }

    function watch() {
        STATES.forEach(function (state) {
            document.querySelectorAll(state[1]).forEach(function (el) {
                if (el.__mirrorWatched) return;
                el.__mirrorWatched = true;
                new MutationObserver(function () { STATES.forEach(sync); })
                    .observe(el, { attributes: true, attributeFilter: ['class', 'hidden'] });
            });
            sync(state);
        });
    }

    watch();
    // The theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', watch);
})();

// The Re:amaze chat panel is rendered by the app with aria-hidden="true" while
// it is closed, but its buttons stay in the Tab order — so the keyboard lands
// on a control screen readers have been told does not exist (audit V1). It is
// app markup, so this mirrors their aria-hidden onto inert from our side
// instead: inert takes the subtree out of the Tab order and the accessibility
// tree together, which is the pairing aria-hidden is missing.
//
// Re:amaze injects late (~8s) and re-renders, so this watches for the nodes
// arriving as well as for the attribute flipping.
//
// aria-hidden alone is not enough to act on: if the app ever left it set while
// the panel was open, inert would break a live support conversation. Measured
// on altenew.com on 09/17/2026, the closed panel is zero-height and sits far
// below the fold, so an open one always has a real box. Requiring both — the
// attribute AND no rendered box — means a visible panel can never be inerted,
// whatever the app does with the attribute. A subtree holding focus is left
// alone for the same reason.
(function reamazeInertWhenHidden() {
    if (!('inert' in HTMLElement.prototype)) return;

    var SELECTOR = '#reamaze-popup, #reamaze-wrapper';

    function apply() {
        document.querySelectorAll(SELECTOR).forEach(function (el) {
            var rect = el.getBoundingClientRect();
            var closed = el.getAttribute('aria-hidden') === 'true' &&
                         rect.width * rect.height === 0 &&
                         !el.contains(document.activeElement);
            if (el.inert !== closed) el.inert = closed;
        });
    }

    new MutationObserver(paceDomPatch(apply)).observe(document.documentElement, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['aria-hidden']
    });

    apply();
})();

// Two gaps in the Commento comment widget's own markup, both confirmed on the
// live article on 09/17/2026 (audit V13, V14):
//   - commenter avatars carry no alt attribute at all, so a screen reader
//     falls back to reading out the image filename. They are decorative — the
//     commenter's name is already text right beside them — so alt="".
//   - the "add an image" control is an <a> holding only a <b> icon: no text,
//     no label, announced as just "link".
// App markup, so it is patched here rather than in Liquid.
//
// The element to watch is <commentify-comments>, not #commento. The app builds
// #commento inside it long after this deferred file runs and rebuilds it as
// comments load, so holding a reference to #commento leaves the observer on a
// detached node and the labels silently stop being applied. Don't narrow this
// back to #commento. <commentify-comments> is rendered by the template, so it
// is already in the DOM at this point and it stays put; it only exists on
// article pages, so the observer costs nothing anywhere else.
(function commentoLabels() {
    var host = document.querySelector('commentify-comments');
    if (!host) return;

    var queued = false;

    function apply() {
        queued = false;
        host.querySelectorAll('img.commento-avatar-img:not([alt])').forEach(function (img) {
            img.setAttribute('alt', '');
        });
        host.querySelectorAll('#commento-add-image-button-root:not([aria-label])').forEach(function (el) {
            el.setAttribute('aria-label', 'Add an image to your comment');
        });
        host.querySelectorAll('#commento-textarea-root:not([aria-label])').forEach(function (el) {
            el.setAttribute('aria-label', 'Write a comment');
        });
        // The hidden file picker is appended outside <commentify-comments>, so
        // look it up from the document rather than the host.
        document.querySelectorAll('#commento-add-image-input:not([aria-label])').forEach(function (el) {
            el.setAttribute('aria-label', 'Choose an image to add to your comment');
        });
    }

    function schedule() {
        if (queued) return;
        queued = true;
        // setTimeout, not requestAnimationFrame: rAF is suspended in a background
        // tab, which would latch queued=true and stop the patch for good.
        window.setTimeout(apply, 0);
    }

    new MutationObserver(schedule).observe(host, { subtree: true, childList: true });

    apply();
})();

// Flickity marks every non-selected cell aria-hidden="true" but leaves the
// links inside them focusable, so Tab walks into slides a screen reader has
// been told are not there. Found by axe (aria-hidden-focus) on the collection
// page sub-collection slider; it is the same defect as the blog carousel and
// the chat panel, and it applies to every Flickity carousel in the theme.
//
// tabindex, NOT inert, and that difference matters here: inert also blocks
// pointer events, and Flickity marks cells aria-hidden while they are still
// partly inside the viewport — measured on 09/17/2026, one hidden cell on
// /collections/all-dies was still within the viewport box. Inerting that would
// stop a visible tile being clickable. Taking the cells out of the Tab order
// clears the violation and leaves the mouse alone.
//
// The previous tabindex is remembered so it can be put back when the cell is
// scrolled to, rather than assuming everything started with no tabindex.
(function flickityHiddenCellsNotTabbable() {
    var FOCUSABLE = 'a[href], area[href], button, input, select, textarea, iframe, [tabindex]';

    function suppress(cell) {
        cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
            if (el.dataset.a11yPrevTabindex !== undefined) return;
            el.dataset.a11yPrevTabindex = el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '';
            el.setAttribute('tabindex', '-1');
        });
    }

    function restore(el) {
        var prev = el.dataset.a11yPrevTabindex;
        if (prev === undefined) return;
        if (prev === '') {
            el.removeAttribute('tabindex');
        } else {
            el.setAttribute('tabindex', prev);
        }
        delete el.dataset.a11yPrevTabindex;
    }

    function apply() {
        document.querySelectorAll('.flickity-slider > [aria-hidden="true"]').forEach(suppress);
        // Anything no longer sitting inside an aria-hidden container goes back
        // to the Tab order with whatever tabindex it had before.
        document.querySelectorAll('[data-a11y-prev-tabindex]').forEach(function (el) {
            if (!el.closest('[aria-hidden="true"]')) restore(el);
        });
    }

    // attributeFilter keeps our own tabindex/data-* writes from re-triggering.
    new MutationObserver(paceDomPatch(apply)).observe(document.documentElement, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['aria-hidden']
    });

    apply();
})();

// Consentmo's accessibility widget (gdpr-backpack, ada_ada_utils.bundle.js)
// writes its own focus style inline on whatever gets keyboard focus:
//   outline: none !important; box-shadow: inset … #2852C3 !important;
//   transition: …; padding-left/right: 2px
// An inline !important beats every stylesheet rule, even our own !important,
// so the rings from the audit and Alarise's design check (grey #949494 on the
// product photos, gold elsewhere) never showed. Measured on altenew.com on
// 10/19/2026. It is an app setting with no "focus outline" switch, so the
// inline style is taken back off here, only on the elements that have a ring
// of their own. Everything else keeps Consentmo's blue ring, which is still a
// visible focus indicator.
//
// The two search fields are listed because their ring is drawn on the box
// around them (:has(...:focus-visible)); without this the field would show
// Consentmo's blue line inside our gold one.
//
// Only the focused element is watched, and only until it loses focus, so this
// costs nothing while nobody is using the keyboard.
(function keepOwnFocusRings() {
    var OWN_RING = [
        '.flickity-enabled',
        'button.accordion',
        '#jm-desc-block .tab button',
        '.wishlist-engine[role="button"]',
        '.pagination-dot',
        '.faq-question',
        '.promo-slider .swiper-pagination-bullet',
        '.course-card__action-item',
        '.site-header__search-input',
        '.wts-hero__search-input'
    ].join(', ');
    var CONSENTMO_BLUE = 'rgb(40, 82, 195)'; // #2852C3, as the browser reports it

    function strip(el) {
        var s = el.style;
        if (s.getPropertyValue('box-shadow').indexOf(CONSENTMO_BLUE) === -1) return;
        s.removeProperty('outline');
        s.removeProperty('box-shadow');
        s.removeProperty('transition');
        if (s.getPropertyValue('padding-left') === '2px') s.removeProperty('padding-left');
        if (s.getPropertyValue('padding-right') === '2px') s.removeProperty('padding-right');
    }

    var watched = null;
    var observer = new MutationObserver(function () {
        if (watched) strip(watched);
    });

    document.addEventListener('focusin', function (e) {
        var el = e.target;
        if (!el.matches || !el.matches(OWN_RING)) return;
        observer.disconnect();
        watched = el;
        strip(el);
        observer.observe(el, { attributes: true, attributeFilter: ['style'] });
    }, true);

    document.addEventListener('focusout', function (e) {
        if (e.target !== watched) return;
        observer.disconnect();
        // Consentmo may write once more as focus leaves; clear that too.
        window.setTimeout(function () { strip(e.target); }, 0);
        watched = null;
    }, true);
})();

/* ATC on collection/homepage cards — vanilla fetch so deferred jQuery on the
   homepage cannot block add-to-cart or ajaxProduct:added. */
document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var btn = e.target.closest('.hc-form .btn:not(.cart__checkout)');
    if (!btn) return;

    var form = btn.closest('form');
    if (!form || !form.classList.contains('hc-form')) return;

    e.preventDefault();

    // Per-form guard for paths the CTA lock cannot see (PDP subscription add-ons).
    if (form.getAttribute('data-atc-inflight') === 'true') return;
    form.setAttribute('data-atc-inflight', 'true');
    AltenewCardCTA.hold();

    function done() {
        form.removeAttribute('data-atc-inflight');
        AltenewCardCTA.settle();
    }

    fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
        .then(function (response) { return response.json(); })
        .then(function () {
            var returnTo = form.querySelector('input[name="return_to"]');
            if (returnTo && returnTo.value === '/checkout') {
                window.location = '/checkout';
                return;
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            done();
        })
        .catch(function () {
            done();
        });
}, true);

/* =========================================================================
   08062026-002  Pre-Order add-to-cart on the Searchanise results page

   Searchanise renders pre-order products with the label "Pre-Order" and
   without its own snize-add-to-cart-button class, so the button was inert and
   the click just bubbled to the a.snize-view-link wrapping the card and went
   to the PDP. That button config lives in the Searchanise dashboard, not in
   this theme, so add the cart behaviour here instead.

   The li carries data-product-variant, which is all /cart/add.js needs. The
   relabel block further down keeps removing snize-add-to-cart-button from
   these cards on purpose: if Searchanise ever starts emitting it, its handler
   and this one would both fire and add the item twice.
   ========================================================================= */
document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var btn = e.target.closest('.snize-button');
    if (!btn || btn.classList.contains('snize-add-to-cart-button')) return;

    var li = btn.closest('li.snize-product');
    if (!li || !li.classList.contains('snize-product-tag-preorder_product')) return;

    var variantId = li.getAttribute('data-product-variant');
    if (!variantId) return;

    // Capture phase: cancels the a.snize-view-link navigation and stops
    // Searchanise's own handlers before they can run.
    e.preventDefault();
    e.stopPropagation();

    AltenewCardCTA.hold();
    $.ajax({
        url: '/cart/add.js',
        data: { id: variantId, quantity: 1 },
        dataType: 'json',
        method: 'post',
        success: function () {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        },
        complete: function () {
            AltenewCardCTA.settle();
        }
    });
}, true);

/*
  The theme's main jQuery ready handler. Everything from here to the matching
  `});` runs as one function, so a throw anywhere inside it silently kills every
  line after it. That is how the Consentmo accessibility launcher came back on
  the cart page: a shipping calculator here called Shopify.Cart.ShippingCalculator,
  Shopify.Cart was never defined, and the throw took out the ~1,400 lines below it
  - the launcher hide and window.openAccessibilityWidget among them. The calculator
  is gone now (see below), but the shape of this handler is still the trap, so keep
  anything that reads a global another script has to define first in a handler of
  its own. 09092026-001

  Removed with it: the template-cart shipping calculator block and its markup in
  snippets/cart-shipping.liquid. Nothing rendered that snippet, so the only script
  that defines Shopify.Cart (api.jquery.js, loaded from inside it) never reached the
  page and the calculator could not have worked. Rebuy Smart Cart owns cart shipping.
*/
$(document).ready(function () {

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        // Leave alone anything the page has already wired up. product-features-faq
        // needs one panel open at a time and binds before this runs.
        if (acc[i].onclick) continue;

        acc[i].onclick = function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel && panel.style) {
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        }
    }

    //Hide the header for VIP
    if (window.location.href.indexOf("https://altenew.com/pages/search-results-page?q") > -1) {
        setTimeout(function () {
            $('#snize-search-results-grid-mode ul li').each(function () {
                // 14zcqnthuc7 Retired cards already carry the vote button (assets/retired-vote.js).
                // Without this, results that arrive inside the 3 s turn it into Add to Bag / Notify Me.
                if (this.hasAttribute('data-retired-card')) return;
                // 14zcqntjpxg Cards with options carry View Options instead (assets/searchanise-results.js).
                // It keeps the snize-button class for its shape, so without the .not() this turned it
                // back into Add to Bag 3 s after load (Jossa, 10/21).
                const $button = $(this).find('.snize-button').not('.sxr-view-options');
                const $labeltext = $(this).find('span.snize-pre-order');
                $button.text("Add to Bag");
                if ($(this).hasClass("snize-product-tag-subscription")) {
                    $button.text("Add to Bag").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-sneak_peek")) {
                    $button.text("Coming soon").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-preorder_product")) {
                    // 08062026-002 removeClass stays, and now matters. Searchanise already
                    // renders these without snize-add-to-cart-button, so this was a no-op; the
                    // theme adds the cart behaviour itself (see the Pre-Order handler at the top
                    // of this file). If Searchanise ever starts emitting the class, its handler
                    // and ours would both fire and add the item twice.
                    $button.text("Pre-Order").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-pksubscription")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-petite")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-sskgrand-exclusive-class")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-promo_ink-cube")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-register-cta")) {
                    $button.text("Register");
                    $labeltext.text("Register");
                } else if ($(this).hasClass("snize-product-tag-join-waitlist-cta")) {
                    $button.text("Join Waitlist");
                    $labeltext.text("Join Waitlist");
                    $(this).find("span.snize-out-of-stock").css("display", "none");
                    $(this).find(".snize-price-list").css("display", "none");
                } else if ($(this).hasClass("snize-product-tag-pre-order-cta")) {
                    $button.text("Pre-Order");
                }

                // Specific condition for retreat_2025 AND out-of-stock
                else if ($(this).hasClass("snize-product-tag-retreat_2025") && $(this).hasClass("snize-product-out-of-stock")) {
                    $(this).find("span.snize-out-of-stock").css("display", "none");
                    $(this).find(".snize-price-list").css("display", "none");
                    $button.html(`
                    <svg style="color: #3c3c3c" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" fill="#3c3c3c"></path>
                    </svg> Notify Me
                `);
                }

                // General out-of-stock condition
                else if ($(this).hasClass("snize-product-out-of-stock")) {
                    $button.html(`
                    <svg style="color: #3c3c3c" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" fill="#3c3c3c"></path>
                    </svg> Notify Me
                `);
                }
            });
        }, 3000); // Run this after 3 seconds
    }

    setTimeout(function () {
        $('#snize-search-results-grid-mode ul li').each(function () {
            var listItem = $(this);
            var selectElement = listItem.find('select.snize-option.snize-option-other');
            var preOrderButton = listItem.find('.snize-button');
            selectElement.on('change', function () {
                setTimeout(function () {
                    if ($("span.snize-pre-order").length) {
                        $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-preorder_product .snize-button.snize-add-to-cart-button").text("Pre-Order");
                    }
                }, 1000); //run this after 3 seconds
            });
        });
    }, 3000); //run this after 3 seconds

    var collectionURL = window.location.href;
    if (collectionURL == "https://altenew.com/collections/stamps-bundles" || collectionURL == "https://altenew.com/collections/pencils-pens" || collectionURL == "https://altenew.com/collections/tools-adhesives") {
        $(".rte.collection__description").css("display", "none");
    }


    //$(".klaviyo-product-container.jm-custom-klaviyo a.btn.klaviyo-bis-trigger").html("<svg style='color: #3c3c3c' xmlns='http://www.w3.org/2000/svg' width='17' height='17' fill='currentColor' class='bi bi-envelope' viewBox='0 0 16 16'> <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' fill='#3c3c3c'></path> </svg>Notify Me");
    //$(".klaviyo-product-container.jm-custom-klaviyo .klaviyo-button-container").css("position","unset");
    $(".klaviyo-product-container.jm-custom-klaviyo").each(function () {
        const isAvailable = $(this).data("is-available");
        const isProductWaitlist = $(this).data("is-product-waitlist");
        const isPKSubscription = $(this).data("is-PK-subscription");

        if (!isAvailable && isProductWaitlist && !isPKSubscription) {
            $(this).find("a.btn.klaviyo-bis-trigger").html("<svg style='color: #3c3c3c' xmlns='http://www.w3.org/2000/svg' width='17' height='17' fill='currentColor' class='bi bi-envelope' viewBox='0 0 16 16'> <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' fill='#3c3c3c'></path> </svg>Join Waitlist");
        } else {
            $(this).find("a.btn.klaviyo-bis-trigger").html("<svg style='color: #3c3c3c' xmlns='http://www.w3.org/2000/svg' width='17' height='17' fill='currentColor' class='bi bi-envelope' viewBox='0 0 16 16'> <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' fill='#3c3c3c'></path> </svg>Notify Me");
        }

        // Product cards keep Notify me in the flow under the price, like Add to Bag. Pinned to the
        // card's bottom it drifted away from the price whenever a neighbour stretched the row
        // (design review 10/14, ClickUp 14zcqntjbqb).
        if (!this.closest('.grid-product__meta')) {
            this.style.setProperty('position', 'absolute', 'important');
        }
    });

    if ($(".pillar-pages")[0]) {
        $(".page-width.page-width--narrow.page-content").attr("id", "pillar-pages");
    }

    if ($(window).width() > 1100) {
        $("#jm-footer-moved").appendTo($("div.footer-section-main .page-width .grid__item.footer__item--77d1c31a-e643-4483-b4d9-da6966635edf .collapsible-content__inner"));
    }

    var urlBlogParams = new URLSearchParams(window.location.search);
    var BlogSearchType = urlBlogParams.get('type');
    if (BlogSearchType == "article") {
        $(".collection-filter__item.collection-filter__item--sort").css("display", "none");
        $("span.grid-search__page-content span.h4").css({
            'font-size': '15px',
            'letter-spacing': 'unset',
            'text-transform': 'capitalize',
            'font-weight': 'bold'
        });
        $(".search-content .grid__item.medium-up--one-fifth.grid__item--sidebar").remove();
        $("form.input-group.search-bar.search-bar--page").remove();
        $(".search-content .grid__item.medium-up--four-fifths.grid__item--content").css("width", "100%");
        $(".search-content header.section-header").html("<a href='/blogs/paper-crafting-inspiration-and-tips' style='margin-top:25px;' class='btn btn--small return-link'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-arrow-left' viewBox='0 0 50 15'><path d='M50 5.38v4.25H15V15L0 7.5 15 0v5.38z'></path></svg> BACK TO THE BLOG</a>");
    }

    $(".product-section .product__thumbs--below .product__thumb-item").each(function () {
        var getCount = $(this).attr('data-index');
        if (getCount > 18) {
            $(".product-section .product__thumbs--below").css({
                'max-height': '300px',
                'overflow-x': 'hidden',
                'overflow-y': 'scroll',
                'position': 'relative',
                '-webkit-overflow-scrolling': 'touch'
            });
            $(".product-section .product__thumbs--below").addClass("custom-horizontal-image-view");
        }
    });

    if (window.location.href.indexOf("/iwish") > -1) {
        window.location.href = "https://altenew.com/pages/wishlist";
    }

    const modal = document.getElementById("myModal");
    const modalImg = document.getElementById("imgContainer");

    $(".vip-program-2023 .column img").on("click", function () {
        const imgSrc = $(this).attr("src");
        if (modal) {
            modal.style.display = "block";
        }
        if (modalImg) {
            modalImg.src = imgSrc;
        }
    });

    // Get the <span> element that closes the modal
    const span = document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    if (span) {
        span.onclick = function () {
            if (modal) {
                modal.style.display = "none";
            }
        };
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        if (modal && event.target === modal) {
            modal.style.display = "none";
            document.body.style.overflow = "auto";
            document.body.style.height = "auto";
        }
    };

    // Store the input fields as variables
    var $barInput = $('.bar-input');
    var $layeringInstructions = $('.layering-instructions');
    var $layeringStencil = $('.layering-stencil');
    var $pressPlates = $('.press-plates');

    // Reusable function for handling accordions
    function handleAccordion(inputElement, accordionContainer, backgroundColorClass) {
        var inputVal = inputElement.val().toLowerCase();
        var accordions = accordionContainer.find('.accordion');
        var searchCount = 0;

        accordions.each(function () {
            var accordion = $(this);
            var panel = accordion.next('.panel');
            var listItems = panel.find('ul li');
            var matchCount = 0;

            listItems.each(function () {
                var listItem = $(this);
                var textContent = listItem.text().toLowerCase();

                if (!inputVal || textContent.indexOf(inputVal) > -1) {
                    listItem.css('display', 'list-item');
                    matchCount++;
                } else {
                    listItem.css('display', 'none');
                }
            });

            if (matchCount === 0) {
                accordion.removeClass('active');
                accordion.removeClass(backgroundColorClass);
                panel.css('max-height', '0'); // Close the panel
            } else {
                accordion.addClass('active'); // Add 'active' class
                accordion.addClass(backgroundColorClass); // Add background color class
                panel.css('max-height', '1000px'); // Open the panel (adjust '1000px' as needed)
            }

            searchCount += matchCount;
        });

        if (inputVal === "") {
            accordions.removeClass('active');
            accordions.removeClass(backgroundColorClass);
            accordions.show(); // Show all accordions when the input is empty
            var panels = accordionContainer.find('.panel');
            panels.css('max-height', ''); // Reset max-height for all panels
        } else {
            accordions.not('.active').hide(); // Hide non-active accordions
        }

        if (searchCount < 318 && searchCount !== 0) {
            accordionContainer.find('.no-results').css("display", "none");
        } else if (searchCount === 0) {
            accordionContainer.find('.no-results').css("display", "block");
        }
    }

    // Attach event handlers
    $barInput.on('keyup', function () {
        handleAccordion($barInput, $('#layering-guides'), 'background-color-class1');
    });

    $layeringInstructions.on('keyup', function () {
        handleAccordion($layeringInstructions, $('#layering-instructions'), 'background-color-class2');
    });

    $layeringStencil.on('keyup', function () {
        handleAccordion($layeringStencil, $('#layering-stencil'), 'background-color-class3');
    });

    $pressPlates.on('keyup', function () {
        handleAccordion($pressPlates, $('#press-plates'), 'background-color-class3');
    });

    /*All links open in new tab 12/10/2024*/
    $('#layering-guides a, #layering-instructions a, #layering-stencil a, #marvelous-monthly-series a', '#press-plates a').attr('target', '_blank');

    if ($("#zp-entity-content-wrapper").length) {
        $("div.free-shipping-bar-section").css("display", "none");
        $("[data-section-type='header']").css("display", "none");
        $("div.footer-promotions-section").css("display", "none");
        $(".back-to-top").css("display", "none");

        setInterval(function () {
            $("div#giftbox-root").hide();
            $("div#giftbox-root").css("opacity", "0");
            $("div#smile-ui-container").hide();
            $("div#smile-ui-container").css("opacity", "0");
        }, 1000);
    }

    if ($("#zp-entity-content-wrapper").length) {
        $("div.free-shipping-bar-section").css("display", "none");
        $("[data-section-type='header']").css("display", "none");
        $("div.footer-promotions-section").css("display", "none");
        $(".back-to-top").css("display", "none");

        setInterval(function () {
            $("div#giftbox-root").hide();
            $("div#giftbox-root").css("opacity", "0");
            $("div#smile-ui-container").hide();
            $("div#smile-ui-container").css("opacity", "0");
        }, 1000);
    }


    $('#jm-alert-notification .modal__close .icon').click(function () {
        $("#jm-alert-notification").removeClass("modal--is-active");
    });

    // js-cookie ships inside vendor-scripts-v11.js, which the homepage no longer
    // loads. Guard rather than assume it is there: this sits inside the ready
    // handler opened at line 339, so a ReferenceError here kills every statement
    // below it - which is how the accessibility widget lost its launcher-hide and
    // its gold ~90 lines further down.
    if (typeof Cookies !== 'undefined' && (!Cookies.get('first_visit') || Cookies.get('first_visit') !== 'true')) {
        // set the cookie with a value
        Cookies.set('first_visit', 'true', {expires: 3650});
    }

    var pageURL = window.location.href;
    if (pageURL == "https://altenew.com/pages/new-to-altenew") {
        setInterval(function () {
            $("div#giftbox-root").hide();
            $("div#giftbox-root").css("opacity", "0");
            $("div#smile-ui-container").hide();
            $("div#smile-ui-container").css("opacity", "0");
        }, 1000);
    }

    $("div.footer-section-main .footer__newsletter input.footer__newsletter-input").attr("required", 'true');

    function updateBulletList() {
        var selectedOption = $('.variant-input-wrap select').val(); // Get the selected option value
        var bulletIndex = $('.variant-input-wrap select').prop('selectedIndex'); // Get the selected option index

        // Update the bullet list based on the selected option index
        $('#variantDiscountCodeList li').eq(bulletIndex).show().siblings().hide();
    }

    // Trigger the function on page load
    updateBulletList();

    // Event listener for option list change
    $('.variant-input-wrap select').change(function () {
        updateBulletList();
    });

    /*
     * Opens the Consentmo accessibility widget. The widget lives in the shadow
     * DOM of <csm-web-accessibility>, so the app's own API is the only reliable
     * handle on it — clicking the launcher button is just a fallback for the
     * moment before Consentmo has finished booting its API.
     */
    window.openAccessibilityWidget = function () {
        applyAccessibilityWidgetStyles();
        var accessibility = window.Consentmo && window.Consentmo.accessibility;
        if (accessibility && typeof accessibility.open === 'function') {
            accessibility.open();
            return true;
        }
        var host = document.querySelector('csm-web-accessibility');
        var launcher = host && host.shadowRoot && host.shadowRoot.querySelector('button');
        if (launcher) {
            launcher.click();
            return true;
        }
        return false;
    };

    /*
     * Consentmo draws its launcher and its panel inside the shadow DOM, so theme
     * CSS cannot reach either one — a <style> appended to the shadow root is the
     * only way in. Two changes live here:
     *
     *   - the floating launcher is hidden. The widget is opened from the footer
     *     legal link and the "Display Accessibility Widget" links instead, so the
     *     button in the corner is redundant.
     *   - the panel gets the theme's body font, read off <body> so it follows
     *     whatever font is set in the theme customizer.
     *
     *   - the panel is recoloured from Consentmo's blue to the theme's gold.
     *
     * The rules are anchored on Consentmo's stable ids. Their class names are
     * build hashes (.TmCIazCWB1fPALe1iLC3) that change between app releases, so
     * nothing here may depend on them.
     *
     * The colour is the awkward part. Consentmo writes its brand colour inline
     * onto ~30 elements, so a stylesheet cannot win: overriding their custom
     * properties with !important repaints exactly one of eight blue elements, and
     * the rest carry literal inline background/color or SVG fills. So the colours
     * are rewritten by value instead of by selector — find whatever colour the app
     * is configured with, then replace that value wherever it appears. That keeps
     * working if Consentmo reshuffles their markup, and quietly becomes a no-op if
     * the brand colour is ever set to the gold in the app's own admin, which is
     * still the better place for it.
     */
    var ACCESSIBILITY_STYLE_ID = 'altenew-accessibility-widget-styles';
    // The deep gold, not the light #d2ae67 the previous Accessibly widget used.
    // The app paints this colour two ways and only the deep gold passes both: as
    // text on the white card it is 4.7:1, where #d2ae67 was 2.1:1 and failed; as
    // a bar behind text it carries white at 4.7:1. So text on it is WHITE, the
    // opposite of what the light gold needed - dark #1d1d1d on this one is 3.6:1
    // and fails. Check both directions before changing this pair.
    var ACCESSIBILITY_BRAND = '#8e7005';
    var ACCESSIBILITY_ON_BRAND = '#ffffff';
    var recolouringAccessibilityWidget = false;

    function applyAccessibilityWidgetStyles() {
        var host = document.querySelector('csm-web-accessibility');
        var root = host && host.shadowRoot;
        if (!root) return false;
        if (root.getElementById(ACCESSIBILITY_STYLE_ID)) return true;

        var themeFont = getComputedStyle(document.body).fontFamily || 'Montserrat, sans-serif';
        var style = document.createElement('style');
        style.id = ACCESSIBILITY_STYLE_ID;
        style.textContent =
            '#csm-ada-toggle-widget-button { display: none !important; }\n' +
            '#csm-ada-compliance-wrapper *, #csm-ada-popover * {' +
            ' font-family: ' + themeFont + ' !important; }\n' +
            /* Cheap and selector-free, so worth doing even though it only catches
               the few elements that actually read these. */
            '#csm-ada-compliance-wrapper, #csm-ada-compliance-wrapper * {' +
            ' --ada-banner-color: ' + ACCESSIBILITY_BRAND + ' !important;' +
            ' --ada-banner-text-color: ' + ACCESSIBILITY_ON_BRAND + ' !important;' +
            ' --ada-card-background: ' + ACCESSIBILITY_BRAND + ' !important;' +
            ' --ada-card-color: ' + ACCESSIBILITY_ON_BRAND + ' !important;' +
            ' --ada-switcher-color-active: ' + ACCESSIBILITY_BRAND + ' !important; }';
        root.appendChild(style);
        recolourAccessibilityWidget(root);
        watchAccessibilityWidget(root);
        return true;
    }

    function accessibilityHexToRgb(hex) {
        var h = hex.replace('#', '');
        return 'rgb(' + parseInt(h.slice(0, 2), 16) + ', ' +
            parseInt(h.slice(2, 4), 16) + ', ' + parseInt(h.slice(4, 6), 16) + ')';
    }

    function recolourAccessibilityWidget(root) {
        // Read the app's configured colour off its own inline custom property
        // rather than assuming it is still their default blue.
        var source = null;
        var carriers = root.querySelectorAll('[style*="--ada-banner-color"]');
        for (var i = 0; i < carriers.length && !source; i++) {
            var match = carriers[i].getAttribute('style').match(/--ada-banner-color:\s*(#[0-9a-fA-F]{6})/);
            if (match) source = match[1];
        }
        if (!source || source.toLowerCase() === ACCESSIBILITY_BRAND) return;

        var sourceRgb = accessibilityHexToRgb(source);
        var isSource = function (value) {
            return value && (value.toLowerCase() === source.toLowerCase() || value === sourceRgb);
        };

        recolouringAccessibilityWidget = true;

        root.querySelectorAll('[style]').forEach(function (el) {
            var before = el.getAttribute('style');
            var after = before.split(source).join(ACCESSIBILITY_BRAND)
                .split(sourceRgb).join(ACCESSIBILITY_BRAND)
                .replace(/--ada-banner-text-color:\s*#FFFFFF/i,
                    '--ada-banner-text-color: ' + ACCESSIBILITY_ON_BRAND);
            // The header/footer bars pair the brand colour with white text inline.
            if (after.indexOf(ACCESSIBILITY_BRAND) !== -1) {
                after = after.replace(/color:\s*(#FFFFFF|rgb\(255, 255, 255\))/i,
                    'color: ' + ACCESSIBILITY_ON_BRAND);
            }
            if (after !== before) el.setAttribute('style', after);
        });

        // Whatever still computes to the old colour came from a hashed-class rule
        // or an SVG attribute, so it needs a direct inline override.
        root.querySelectorAll('*').forEach(function (el) {
            var computed = getComputedStyle(el);
            if (isSource(computed.backgroundColor)) el.style.setProperty('background-color', ACCESSIBILITY_BRAND, 'important');
            if (isSource(computed.color)) el.style.setProperty('color', ACCESSIBILITY_BRAND, 'important');
            if (isSource(computed.fill)) el.style.setProperty('fill', ACCESSIBILITY_BRAND, 'important');
            if (isSource(computed.stroke)) el.style.setProperty('stroke', ACCESSIBILITY_BRAND, 'important');
        });

        /*
         * Anything sitting ON the brand colour has to take the on-brand colour,
         * whatever the app was configured with. The panel header is the case
         * that matters: Consentmo paints it with banner_icon_color, a dark grey
         * set in the app admin, and dark grey on this gold is 3.6:1 - a fail on
         * the one widget that cannot afford one. The pass above only ever
         * rewrote the source colour and white, so it left that grey alone.
         *
         * Keyed on "what is behind this" rather than on a colour value, so it
         * survives their hashed class names and does not care what the admin is
         * set to. Transparent descendants are included because they let the bar
         * show through; anything with a background of its own is left alone, so
         * the brand-on-white text elsewhere in the panel keeps its colour.
         */
        var brandRgb = accessibilityHexToRgb(ACCESSIBILITY_BRAND);
        var isBrandBackground = function (value) {
            return value && (value.toLowerCase() === ACCESSIBILITY_BRAND || value === brandRgb);
        };
        var isTransparent = function (value) {
            return !value || value === 'transparent' || value === 'rgba(0, 0, 0, 0)';
        };
        var paintOnBrand = function (el) {
            var computed = getComputedStyle(el);
            el.style.setProperty('color', ACCESSIBILITY_ON_BRAND, 'important');
            if (computed.fill && computed.fill !== 'none') el.style.setProperty('fill', ACCESSIBILITY_ON_BRAND, 'important');
            if (computed.stroke && computed.stroke !== 'none') el.style.setProperty('stroke', ACCESSIBILITY_ON_BRAND, 'important');
        };

        root.querySelectorAll('*').forEach(function (el) {
            if (!isBrandBackground(getComputedStyle(el).backgroundColor)) return;
            paintOnBrand(el);
            el.querySelectorAll('*').forEach(function (child) {
                if (isTransparent(getComputedStyle(child).backgroundColor)) paintOnBrand(child);
            });
        });

        recolouringAccessibilityWidget = false;
    }

    /*
     * The panel is re-rendered as the visitor toggles options, which restores the
     * app's own inline colours, so the recolour has to run again after each render.
     * Debounced, and it ignores the mutations it causes itself.
     */
    function watchAccessibilityWidget(root) {
        var pending = null;
        new MutationObserver(function () {
            if (recolouringAccessibilityWidget || pending) return;
            pending = setTimeout(function () {
                pending = null;
                recolourAccessibilityWidget(root);
            }, 120);
        }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }

    /*
     * The app boots after this script, so the element usually is not there yet.
     * Watch for it, and give up after 30s rather than leaving an observer running
     * on a page where the app never loads.
     */
    if (!applyAccessibilityWidgetStyles()) {
        var accessibilityObserver = new MutationObserver(function () {
            if (applyAccessibilityWidgetStyles()) accessibilityObserver.disconnect();
        });
        accessibilityObserver.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function () { accessibilityObserver.disconnect(); }, 30000);
    }

    $("a:contains('Display Accessibility Widget')").on("click", function (event) {
        event.preventDefault(); // Prevent default link behavior
        window.openAccessibilityWidget(); // Trigger accessibility widget
    });
    $("img.accessibility-widget-icon").on("click", function (event) {
        event.preventDefault(); // Prevent default link behavior
        window.openAccessibilityWidget(); // Trigger accessibility widget
    });

    // Check if the screen width is greater than 768 and the URL is not one of two specific links
    if (window.innerWidth > 768 && !(window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" || window.location.href === "https://altenew.com/pages/loyalty-program")) {
        // After 1 minute, make an element with the ID "smile-ui-container" fully visible
        setTimeout(function () {
            $("#smile-ui-container").css({'opacity': '1', 'pointer-events': 'auto'});
        }, 60000);
    } else {
        if (window.innerWidth > 768 && (window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" || window.location.href === "https://altenew.com/pages/loyalty-program")) {
            var intervalId = setInterval(function () {
                var container = $("#smile-ui-container");
                // Check if the current style matches the desired style
                if (container.css('display') === 'block' && container.css('opacity') === 'unset') {
                    clearInterval(intervalId); // Stop the interval when styles match
                } else {
                    // Apply the styles
                    container.css('display', 'block');
                    container.css('opacity', 'unset');
                }
            }, 1000); // Repeat every 1 second (adjust as needed)
        }
    }

    // Check if the page URL matches and if the screen width is within mobile range
    if (window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" && window.innerWidth <= 768) {
        var intervalId = setInterval(function () {
            var container = $("#smile-ui-container");

            // Check if the current style matches the desired style
            if (container.css('display') === 'block' && container.css('opacity') === 'unset') {
                clearInterval(intervalId); // Stop the interval when styles match
            } else {
                // Apply the styles
                container.css('display', 'block');
                container.css('opacity', 'unset');
            }
        }, 1000); // Repeat every 1 second (adjust as needed)
    }

    // Check if the page URL matches and if the screen width is within mobile range
    if (window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" && window.innerWidth <= 768) {
        var intervalId = setInterval(function () {
            var container = $("#smile-ui-container");

            // Check if the current style matches the desired style
            if (container.css('display') === 'block' && container.css('opacity') === 'unset') {
                clearInterval(intervalId); // Stop the interval when styles match
            } else {
                // Apply the styles
                container.css('display', 'block');
                container.css('opacity', 'unset');
            }
        }, 1000); // Repeat every 1 second (adjust as needed)
    }

    // Check if the page URL matches and if the screen width is within mobile range
    if (window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" && window.innerWidth <= 768) {
        var intervalId = setInterval(function () {
            var container = $("#smile-ui-container");

            // Check if the current style matches the desired style
            if (container.css('display') === 'block' && container.css('opacity') === 'unset') {
                clearInterval(intervalId); // Stop the interval when styles match
            } else {
                // Apply the styles
                container.css('display', 'block');
                container.css('opacity', 'unset');
            }
        }, 1000); // Repeat every 1 second (adjust as needed)
    }

    // Tap Cart Web Banner delayed 2 minutes
    if (window.innerWidth <= 768) {
        setTimeout(function () {
            $("div#tapcart-web-banner").css('opacity', '1');
            $("div#tapcart-web-banner").css('display', 'block');
        }, 120000);
    }


    // Loop through each element with class "collection-grid__wrapper"
    $(".template-collection .collection-grid__wrapper").each(function () {
        // Find all elements with the attribute data-product-handle equal to "hc-currency"
        $(this).find("[data-product-handle='hc-currency']").remove();
    });

    function getAndLogCustomPrice() {
        var selectedOption = $('select[name="id"] option:selected');
        var dpromotions = $('.shopify-section.double-points-promotions-section .dpromotions').text();
        if (dpromotions == "true") {
            var customPrice = selectedOption.attr('custompricejm') * 2; //Double Points
        } else {
            var customPrice = selectedOption.attr('custompricejm'); //Default Points
        }
        //Hidden points inside the PDP when price is 0 2-15-2024
        if (customPrice > "0") {
            var pointsText = " points";
            var resultDisplay = customPrice + pointsText;
            $('span.product-points').text(resultDisplay);
            $("p.pdp-loyalty-points").css("display", "block");
        } else {
            $("p.pdp-loyalty-points").css("display", "none");
        }
    }

    // Get and log custom price on page load
    getAndLogCustomPrice();

    // Get and log custom price on select change
    $('select[name="id"]').on('change', function () {
        getAndLogCustomPrice();
    });

    var commonParent = $('.grid-product__content');
    // Add event listener for mouseenter on .grid-product__meta and .grid-product__image-mask
    commonParent.on('mouseenter', '.grid-product__meta, .grid-product__image-mask', function () {

        // Find the corresponding .grid-product__secondary-image
        var currentContentElement = $(this);
        var secondaryImage = currentContentElement.closest('.grid-product__content').find('.grid-product__secondary-image');

        // Apply the animation to the found .grid-product__secondary-image
        secondaryImage.css('animation', 'fade-in .2s cubic-bezier(.26,.54,.32,1) 0s forwards');
    });

    // Add event listener for mouseleave on .common-parent (optional)
    commonParent.mouseleave(function () {
        var secondaryImage = $(this).find('.grid-product__secondary-image');
        secondaryImage.css('animation', 'none');
    });

    // Attach keyup event to the input element
    $('.template-article input#CommentEmail').on('keyup', function () {
        // Get the entered email value
        var enteredEmail = $(this).val();

        // Define the allowed email addresses
        var disallowedEmails = ['spo@spo337.com', 'spo@spo', 'spo337.com', 'cityofrosedalems.com', 'pnn9499@gmail.com'];

        // Check if the entered email is in the allowedEmails array
        if (disallowedEmails.includes(enteredEmail)) {
            // Clear the input field if the email is present in the allowedEmails array
            $(this).val('');
        }
    });

    //Hide the header for VIP
    if (window.location.href.startsWith("https://altenew.com/pages/my-crafting-stash")) {
        $(".page-width.page-width--narrow.page-content").css("max-width", "1450px");
    }

    // Iterate through each list item
    $("#CurrencyList-footer .disclosure-list__item").each(function () {
        // Get the text content of the disclosure-list__label span within the current list item
        var labelText = $(this).find(".disclosure-list__label").text();

        // Remove ر.س and د.إ using replace and remove space before closing parenthesis
        var updatedText = labelText.replace(/ر\.س|د\.إ|ر\.ق/g, '').replace(/\s+\)/, ')');

        // Update the text content of the span within the current list item
        $(this).find(".disclosure-list__label").text(updatedText);
    });

    //Selected text
    // Get the text content of the disclosure-list__label span within the button
    var labelText = $(".faux-select .disclosure-list__label").text();

    // Remove ر.س, د.إ, and ر.ق using replace and remove space before closing parenthesis
    var updatedText = labelText.replace(/ر\.س|د\.إ|ر\.ق/g, '').replace(/\s+\)/, ')');

    // Update the text content of the span within the button
    $(".faux-select .disclosure-list__label").text(updatedText);

    // Function to move the US option to the top
    function moveUSToTop() {
        var usOption = $('select.recommendation-modal__selector--flag option[value="US"]');

        if (usOption.length) {
            usOption.prependTo('select.recommendation-modal__selector--flag');
        }
    }

    // Check for the cookie and set up the interval
    setTimeout(function () {
        let localeBarAccepted = getCookie("locale_bar_accepted");

        if (!localeBarAccepted) {
            // Set interval to run every 3 seconds
            setInterval(moveUSToTop, 2000); // 3000 milliseconds = 3 seconds
        }

        const path = window.location.pathname;

        // Shopper geo comes from snippets/shopper-geo.liquid (window.AltShopperGeo)
        // — Shopify's own IP lookup, so no visitor IP leaves to a third party as
        // it did with the old get.geojs.io call. isEU covers the EU/EEA member
        // states (the legally correct GPSR scope).
        //
        // Waited on rather than read straight off the object: AltShopperGeo starts
        // out holding the *market's* country, which is the primary market (US) for
        // any shopper who has not picked one. Acting on that told EU buyers they
        // were not in the EU and hid the GPSR notice from them, and told
        // international shoppers they were in the US so they never saw the
        // shipping-restriction notice. .ready settles on the real country, and
        // resolves on the spot once the session has it cached, so only the first
        // page of a visit waits for it. ClickUp 86d3ycyw4.
        var geoSource = window.AltShopperGeo || { isUS: true, isEU: false };

        // Collections that cannot ship outside the US. Matched on the handle rather
        // than with path.includes(), because "collections/artist-markers" stopped
        // matching when that collection was renamed — /collections/artist-markers
        // now 301s to /collections/easy-blending-altenew-artist-markers, and a
        // substring test against the old path silently stopped firing.
        // 03182026-001 removed the organizational labels collection from this list.
        var RESTRICTED_COLLECTIONS = [
            "alcohol-markers",
            "artist-markers",
            "easy-blending-altenew-artist-markers",
            "alcohol-inks",
            "alcohol-markers-inks-bundle"
        ];

        var RESTRICTION_NOTICE =
            "<p class='disclaimerCollection'>Oops! The products in this collection cannot be shipped outside of the U.S. We know it's a bummer, but don't let it hinder your creativity!<br/> Click <a href='https://altenew.com/pages/artistrybyaltenew'>HERE</a> to browse more unique crafting goodies.</p>";

        function currentCollectionHandle() {
            var match = path.match(/\/collections\/([^\/?#]+)/);
            return match ? match[1] : null;
        }

        // The notice used to be hung off ".template-collection .rte.collection__description",
        // which matched on none of these collections:
        //   - alcohol-inks and alcohol-markers-inks-bundle render under a custom
        //     template, so the body class is "template-collection-artistrybyaltenew".
        //     Class matching is per whole token, so ".template-collection" never hit.
        //   - alcohol-markers has no collection description, so there was no
        //     element to sit in front of in the first place.
        // Hence: no ancestor requirement (the handle check above already scopes
        // this to the right pages), and a fallback anchor when there is no
        // description.
        function showRestrictionNotice() {
            if ($(".disclaimerCollection").length) return;

            var $description = $(".rte.collection__description").first();
            if ($description.length) {
                $description.before(RESTRICTION_NOTICE);
            } else {
                var $content = $(".grid__item--content").first();
                if (!$content.length) return;
                $content.prepend(RESTRICTION_NOTICE);
            }

            $(".main-content").css("min-height", "auto");
        }

        function applyShopperGeo(geo) {
            // Runs once per page. Written so a second run would still be safe:
            // the notice is not injected twice, and the GPSR notice is set both
            // ways rather than only hidden.
            var isRestrictedCollection =
                RESTRICTED_COLLECTIONS.indexOf(currentCollectionHandle()) !== -1;

            if (!geo.isUS && isRestrictedCollection) {
                showRestrictionNotice();
            } else {
                $(".disclaimerCollection").remove();
            }

            // Only ever revealed, never re-hidden: the anchor ships with an
            // inline style="display:none" (blocks/collection-title.liquid) and
            // no stylesheet rule re-asserts it, so clearing the inline style
            // would show the button to US shoppers instead of hiding it.
            if (!geo.isUS) {
                $("a.monthly-subscription-button").css("display", "inline-block");
            }

            // GPSR notice: EU/EEA only. Shown by default in the markup, so this
            // has to hide it for everyone else and put it back if geo changes.
            $(".gpsr-container").toggle(!!geo.isEU);
        }

        (geoSource.ready || Promise.resolve(geoSource)).then(applyShopperGeo);

        // ✅ SYNTAX FIX: close the setTimeout you opened above
    }, 0);

    /*
      Initial visibility of the variant-level "Notify Me" block. The old probe
      read the CTA label through a `.btn--secondary` selector the product form
      never renders, so the label always came back empty, every PDP fell to the
      else branch, and in-stock products showed the notify pill floated beside a
      live Add to Bag. Read the button's own disabled state instead — the form
      sets it exactly when the selected variant can't be bought, and theme.js
      keeps it in sync on variant change.
    */
    var $PDP_atc = $("#addToCartCTA");
    var PDP_variant_sold_out = $PDP_atc.length > 0 && $PDP_atc.is(":disabled");
    if (!PDP_variant_sold_out) {
        $("#notify-me-variant-options").css("display", "none");
        $(".dropdown-moved .variant-input-wrap select option").removeAttr("disabled"); /* Dropdown-moved due to moving the element from left to right */
    } else {
        $("#notify-me-variant-options").css("display", "block");
        $(".dropdown-moved.variant-input-wrap select option").removeAttr("disabled"); /* Dropdown-moved due to moving the element from left to right */
    }

    // Function to synchronize selections between Select 1 and Select 2
    function syncSelectOptions() {
        var $select1 = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select');
        // Only sync if there is exactly one dropdown select to avoid deselecting/corrupting option state
        if ($select1.length === 1) {
            var selectedIndex = $select1.prop('selectedIndex');
            if (typeof selectedIndex !== 'undefined' && selectedIndex !== -1) {
                $('select.product-single__variants.no-js').prop('selectedIndex', selectedIndex);
            }
        }
    }

    // Run the function when the page loads
    syncSelectOptions();
    checkSelectedOption();


    // Function to check the selected option
    // The sticky bar's vote button on retired pages (snippets/product-template.liquid)
    // is left out of the buy-button restyling below: it keeps the retired colours
    // and never gets disabled as "Sold Out" (14zcqntmb5j).
    function checkSelectedOption() {
        var selectedOption = $('option:selected', 'select.product-single__variants.no-js');
        var attributeValue = selectedOption.attr('continuesellingoos');
        var ProductTypeJM = $("input.ProductTypeJM").val();
        var PreOrderJM = $("input.PreOrderJM").val();
        var RegisterJM = $("input.RegisterJM").val();
        var JoinWaitListJM = $("input.JoinWaitListJM").val();
        var IsBuyNow = "false";
        $("input.IsBuyNow").each(function () {
            if ($(this).val() === "true") {
                IsBuyNow = "true";
            }
        });
        if (attributeValue == "continue") {
            if (ProductTypeJM !== "Class Bundle" && ProductTypeJM !== "Workshop" && ProductTypeJM !== "Gift Cards" && RegisterJM === "false") {
                $("h2.shipping-period").css("display", "block");
                $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Pre-Order");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").prop('disabled', false);
                $("div#custom-sticky-header-jm button span").text("PRE-ORDER");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("background-color", "#000");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("color", "#FFFFFF");
            } else if (RegisterJM == "true") {
                $("h2.shipping-period").css("display", "block");
                $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Register");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").prop('disabled', false);
                $("div#custom-sticky-header-jm button span").text("REGISTER");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("background-color", "#000");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("color", "#FFFFFF");
            } else if (JoinWaitListJM == "true") {
                $("h2.shipping-period").css("display", "block");
                $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Join Waitlist");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").prop('disabled', false);
                $("div#custom-sticky-header-jm button span").text("Join Waitlist");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("background-color", "#000");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("color", "#FFFFFF");
            }
        } else if (attributeValue == "deny") {
            $("h2.shipping-period").css("display", "none");
            var default_text = IsBuyNow == "true" ? "Buy Now" : "Add to Bag";
            var sticky_text = IsBuyNow == "true" ? "BUY NOW" : "ADD TO BAG";
            $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text(default_text);
            $("div#custom-sticky-header-jm button:not([data-retired-vote])").prop('disabled', false);
            $("div#custom-sticky-header-jm button span").text(sticky_text);
            $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("background-color", "#000");
            $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("color", "#FFFFFF");
        } else {
            if (attributeValue == "oos" && JoinWaitListJM != "true") {
                $("h2.shipping-period").css("display", "none");
                $("#notify-me-variant-options").css("display", "block");
                // Same wording as the main button, which Loop's widget also writes (ClickUp 14zcqntjbqb).
                var sold_out_text = ((window.theme && theme.strings && theme.strings.soldOut) || "Out of Stock").toUpperCase();
                $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text(sold_out_text);
                // The bar offers the back-in-stock sign-up rather than a dead button, as on a
                // fully sold-out product; #pdp-trigger's click opens it (design review 10/26).
                var has_notify = $("#notify-me-variant-options a.klaviyo-bis-trigger").length > 0;
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").prop('disabled', !has_notify);
                $("div#custom-sticky-header-jm button span").text(has_notify ? "NOTIFY ME WHEN AVAILABLE" : sold_out_text);
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("background-color", "#d3d3d3");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("border", "1px solid #d3d3d3");
                $("div#custom-sticky-header-jm button:not([data-retired-vote])").css("color", "#3c3c3c");
            } else if (attributeValue == "oos" && JoinWaitListJM == "true") {
                $(".product-single__form .add-to-cart.btn--secondary:disabled").css("display", "none");
            }
        }
    }

    // Attach change event handler
    $('select.product-single__variants.no-js').change(function () {
        checkSelectedOption();
    });
    setTimeout(function () {
        checkSelectedOption();
    }, 3000);

    /*
      Keep the "Only N left!" scarcity block on the PDP tied to the selected
      variant.

      The block is rendered by snippets/product-inventory-scarcity.liquid, which
      the theme's own inventory updater never touches — that one keys off
      [data-product-inventory] and this PDP outputs .inventoryWrapper instead.
      So the count stuck at whatever the first paint produced: pick a variant
      with 3 left, switch to a sold-out one, and the bar still promised 3 next to
      a disabled Sold Out button and a Notify Me link.

      theme.Variants already resolves the whole variant object out of the
      [data-variant-json] payload — inventory_quantity included — and fires
      'variant:change' on document, so re-derive the same condition the snippet
      uses and rewrite the block in place.
    */
    function syncInventoryScarcity(variant) {
        var wrapper = document.querySelector('[data-inventory-wrapper]');
        if (!wrapper) return;

        var threshold = parseInt(wrapper.dataset.threshold, 10) || 10;
        var quantity = variant ? parseInt(variant.inventory_quantity, 10) : NaN;
        var show =
            !!variant &&
            variant.available === true &&
            variant.inventory_management === 'shopify' &&
            !isNaN(quantity) &&
            quantity > 0 &&
            quantity < threshold;

        if (show) {
            var count = wrapper.querySelector('[data-inventory-count]');
            var progress = wrapper.querySelector('[data-inventory-progress]');
            if (count) count.textContent = quantity;
            if (progress) progress.setAttribute('value', quantity);
        }

        wrapper.hidden = !show;
    }

    document.addEventListener('variant:change', function (evt) {
        var variant = evt.detail && evt.detail.variant;

        /*
          'variant:change' is a document-level event, so quick view and any other
          product form on the page fire it too. Only act on a variant this page's
          own form can actually sell; a null variant is an impossible option
          combination, which should still clear the bar.
        */
        if (variant && !document.querySelector('select[data-product-select] option[value="' + variant.id + '"]')) {
            return;
        }

        syncInventoryScarcity(variant);
    });

    var countdownTimer = $(".countdown-container").data('countdown-timer');
    if (countdownTimer) {
        // Explicitly define the target end time in New York time
        let targetEndTime = countdownTimer;

        // Parse the target time into a Date object
        let countdownDate = new Date(
            new Intl.DateTimeFormat("en-US", {
                timeZone: "America/New_York",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            }).format(new Date(targetEndTime))
        );

        // Start the countdown
        var x = setInterval(function () {
            // Get the current time in New York time
            let now = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
            now = new Date(now);

            // Calculate the remaining time
            let distance = countdownDate - now;

            if (distance >= 0) {
                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                $('#countdown').html(`${days}d ${hours}h ${minutes}m ${seconds}s`);
            } else {
                clearInterval(x);
                $('.countdown-container').css("display", "none");
            }
        }, 1000);
    }

    // ".payment-buttons button" also matched the quantity - / + buttons, so jQuery cloned the
    // Loop widget into the 80px quantity box (and left three nodes sharing one id). Loop then
    // filled the first copy by id, which is why the purchase options rendered squashed inside
    // the quantity stepper. Move the single widget in front of the real add-to-cart button.
    var $loopWidget = $(".loop-widget-container").first();
    var $addToCartCTA = $(".jmc-cart-wishlist.right .CTAs-container > button[data-add-to-cart]").first();
    if ($loopWidget.length && $addToCartCTA.length) {
        $loopWidget.insertBefore($addToCartCTA);
    }

    checkAndClick();


    let titlePrivacyPolicy = $(".shopify-policy__title h1");
    let titledatasalesoptOut = $("header.hc-header.section-header h1.section-header__title");
    let titledatasalesoptOutnav = $("nav.breadcrumb span:nth-child(3)");

    if (titlePrivacyPolicy.text().trim() === "Privacy policy") {
        titlePrivacyPolicy.text("Privacy Notice");
    }

    if (titledatasalesoptOut.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOut.text("Do Not Sell or Share My Personal Data");
    }

    if (titledatasalesoptOutnav.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOutnav.text("Do Not Sell or Share My Personal Data");
    }

    $(".notify-me").each(function () {
        if ($(this).find("a").text().trim() === "Join Waitlist") {
            $(this).addClass("join-waitlists");
        }
    });

    var firstLoad = true;

    function updateSelectedIndex() {
        var $allTabs = $('.tabcontent[data-index]');
        if ($allTabs.length === 0) return;
        var $selectOptions = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select option');
        var selectedIndex = $selectOptions.filter(':selected').index() + 1;
        var $targetTab = $('.tabcontent[data-index="' + selectedIndex + '"]');
        // Logic: Always show if only 1 tab exists, otherwise toggle based on variant selection
        if ($allTabs.length === 1) {
            // If there's only one tab (data-index="1"), ensure it is visible
            $('.tabcontent[data-index="1"]').show().removeClass("hc-hidden");
        } else if ($selectOptions.length > 1) {
            // 04082026-001: Standard toggle logic for multiple variants
            $('.tabcontent').removeAttr("style").addClass("hc-hidden");
            $targetTab.show().removeClass("hc-hidden");
        }

        // Handle height adjustment and visibility
        function showAndAdjust() {
            // Reveal the selected (or only) one properly
            var $activeTab = ($allTabs.length === 1) ? $('.tabcontent[data-index="1"]') : $targetTab;

            $activeTab.removeClass('hc-hidden').css('display', 'contents');

            var $activeContentInner = $activeTab.find('.collapsible-content__inner.rte');
            var contentHeight = $activeContentInner.outerHeight(true);

            $('#jm-desc-block .single__meta_desc').css('height', 'auto').height(contentHeight);
        }

        // Delay only on first load
        if (firstLoad) {
            setTimeout(showAndAdjust, 3000);
            firstLoad = false;
        } else {
            showAndAdjust();
        }
    }

    // Run on page load
    updateSelectedIndex();

    // Run on change
    $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').on('change', updateSelectedIndex);

    setTimeout(function () {
        $("<div class='subcribe-save-tooltip-text'><div class='subcribe-save-tooltip-text-arrow'></div><div><p><strong>Disclaimer:</strong> <br/> If you already have an active subscription, please click <a href='https://altenew.myshopify.com/a/loop_subscriptions/auth?customer_id=1&myshopify_domain=altenew.myshopify.com&locale=en&source=CUSTOMER_ACCOUNT' target='_blank' style='color:#ffffff;text-decoration:underline;'>active subscription</a> to check your subscription status. Continuing without reviewing your current plan may result in a duplicate charge.</p></div></div>").prependTo("[data-loop-widget-selling-plan-group]"); // 03132026-001 web accessibility fix

        // Points update for subscription related products
        if ($(".loop-widget-container").length && !$(".loop-widget-container").hasClass("loop-display-none")) {
            var optionPrice = $(".loop-widget-purchase-option.loop-widget-purchase-option-selected .loop-widget-purchase-option-price").text();
            // Remove $ and trailing decimals
            optionPrice = optionPrice.replace(/\$/g, "").trim();      // Remove $
            optionPrice = optionPrice.split(".")[0];                  // Remove decimal and after
            $("p.pdp-loyalty-points span.product-points").text(optionPrice + ' points');
        }

        $(document).on("click", ".loop-widget-purchase-option, .loop-widget-purchase-option-radio", function () {
            // Find the closest .loop-widget-purchase-option (handles both direct and nested clicks)
            var parentOption = $(this).closest(".loop-widget-purchase-option");

            // Wait a moment in case Loop's JS updates the class after click
            setTimeout(function () {
                if (parentOption.hasClass("loop-widget-purchase-option-selected")) {
                    var optionPrice = parentOption.find(".loop-widget-purchase-option-price").text();

                    // Clean the price
                    optionPrice = optionPrice.replace(/\$/g, "").trim().split(".")[0];

                    $("p.pdp-loyalty-points span.product-points").text(optionPrice + " points");
                }
            }, 10);
        });
    }, 4000);


    window.addEventListener("onCoursesRendered", () => {
        if (document.querySelector('select#tagsFilter')) {
            document.querySelectorAll('select#tagsFilter option').forEach((element) => {
                if (element.getAttribute('data-attr-tagname') != 'all' && !element.getAttribute('data-attr-tagname').includes('Class Instructor')) {
                    element.remove();
                }
                /* 05.02.2026 Courses Plus change All to Filter by Instructor and remove Class Instructor_ */
                if (element.getAttribute('data-attr-tagname').includes('Class Instructor')) {
                    element.textContent = element.textContent.replace("Class Instructor_", "");
                }
                if (element.getAttribute('data-attr-tagname') == 'all') {
                    element.textContent = "Filter by Instructor";
                }
            })
        }
        /* 28.01.2026 Courses Plus new Class Technique filter on courses page */
        if (typeof productsBlock != "undefined") {
            var techFilter = [];

            Object.values(productsBlock).forEach((element) => {
                if (typeof element.tags != "undefined") {
                    if (element.tags !== null) {
                        let splitedArray = element.tags.split(',');

                        techFilter = [...new Set([...techFilter, ...splitedArray])];
                    }
                }
            })

            if (techFilter.length) {
                techFilter = techFilter.filter(item => item.includes("Class Technique_"));

                var select = document.createElement("select");
                select.id = "customTechFilter";

                select.addEventListener("change", function () {
                    runSelectedRegularFilering(this);
                });

                var allTag = document.createElement("option");
                allTag.textContent = 'Filter by technique';
                allTag.dataset.attrTagname = 'all';
                allTag.selected = true;
                select.appendChild(allTag);

                techFilter.forEach(tag => {
                    var option = document.createElement("option");
                    option.textContent = tag.replace(/^Class Technique_/, "");

                    option.dataset.attrTagname = tag;

                    select.appendChild(option);
                });

                if (document.querySelector('#tagsFilter')) {
                    document.querySelector('#tagsFilter').insertAdjacentElement('afterend', select);
                }
            }
        }
    });

    if (window.location.hash === "#autoadd") {
        setTimeout(function () {
            const $addToCartButton = $(".payment-buttons button.btn.btn--full.add-to-cart");
            if ($addToCartButton.length) {
                $addToCartButton.trigger("click");
            }
        }, 4500);
    }

    if (window.location.hash === "#welcome-series") {
        $("ul#variantDiscountCodeList").css("display", "block");
        $("ul#variantDiscountCodeList span.newDiscountCode").text("(with CRAFTINGFUN)");
    }

    if (window.location.pathname === '/pages/whats-your-signature-cardmaking-style') {
        $(".page-width.page-width--narrow.page-content header.hc-header.section-header").css("display", "none");
    }

    if (window.location.href.indexOf("/products/hawaiian-shores-dual-tip-pens") > -1 || window.location.href.indexOf("/products/mini-poppy-stamp-set") > -1 || window.location.href.indexOf("/products/daisy") > -1) {
        setTimeout(function () {
            $(".add-to-cart.btn--secondary span").text("Try It Today");
        }, 3000);
    }

    if (window.location.hash === "#winback-flow-3") {
        $("ul#variantDiscountCodeList").css("display", "block");
    }

    $(".switch-apps-gallery-hero__content").on("click", function () {
        const btn = $("a.btn.btn--primary.button.button--primary.button--solid.Button.Button--primary.rendered").get(0);
        if (btn) btn.click(); // native click
    });

    if (window.location.href.indexOf("/products/craft-your-life-project-kit-monthly-subscription-plan") > -1 || window.location.href.indexOf("/products/build-a-garden-monthly-subscription-plan") > -1 || window.location.href.indexOf("/products/craft-a-flower-monthly-subscription-plan") > -1 || window.location.href.indexOf("/products/stampwheel-2-0") > -1 || window.location.href.indexOf("/products/9x12-ultra-sticky-mat-grid") > -1 || window.location.href.indexOf("cts/stampwheel") > -1) {
        setTimeout(function () {
            if (window.location.href.indexOf("/products/stampwheel-2-0-next-level-stamping") > -1) {
                //$(".add-to-cart.btn--secondary span").text("Pre-order today");
            } else {
                $(".add-to-cart.btn--secondary span").text("Try it Today");
            }
        }, 3000);
    }

    setTimeout(function () {
        $(".CTA-get-offer").text("Get Offer");
    }, 4000);

    // slick is only loaded on pages that render the slick-assets snippet
    if (typeof $.fn.slick === 'function' && $('.collection-list-slider').length) {
        $('.collection-list-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: true,
            infinite: false,
            adaptiveHeight: true,
            arrows: false
        });
    }
});

/*Show launcher when PDP points is click*/
$(document).on('click', '.pdp-loyalty-points', function (event) {
    event.preventDefault();

    // Get the current URL hash
    var currentHash = window.location.hash;

    // Check if #smile-home is already in the URL
    if (currentHash === '#smile-home') {
        // If #smile-home is present, remove it
        window.location.hash = '';
    } else {
        // If #smile-home is not present, add it
        window.location.hash = 'smile-home';
        $("#smile-ui-container").css({'opacity': 'unset', 'pointer-events': 'auto'});

        // Smile opens on that hash once it loads, but script-deferral can still
        // be holding it: show the points as busy until it is there (14zcqntjbqb).
        if (window.altenewWaitForApp && !window.SmileUI) {
            window.altenewWaitForApp(this, function () { return !!window.SmileUI; }, function () {});
        }
    }
});

/* Removing cart item */
$(window).on('load', function () {
    $(document).on('click', '#CartDrawer .cart__remove a', function (e) {
        e.preventDefault(); // Prevent the default link behavior

        if ($('#CartDrawer').hasClass('drawer--is-open')) {

            /*
              Mark the control before handing off, so the trash icon turns into
              a spinner for the ~1.3s the removal is in flight instead of
              looking untouched. custom-cart-drawer.css draws it off this
              class and makes the control inert, which is also what stops a
              second click queueing a second mutation.

              Nothing takes the class off again on the way out: the rebuild
              that ends the wait replaces the whole row, so the node wearing it
              is gone. The stepper's own .is-loading, added below by
              theme-v1.0.1.js, works the same way.
            */
            $(this).closest('.cart__remove')
                .addClass('is-removing')
                .attr('aria-busy', 'true');

            var qtyInput = $(this).closest('.cart__item').find('.js-qty__num');
            qtyInput.val(0);

            // Trigger the minus button click for the specific item
            $(this).closest('.cart__item').find('.js-qty__adjust--minus').click();

            // Additional logic for each item after reducing the quantity to 0
        }
    });

    var checkClass = $(".section-header--404");
    if (checkClass.length > 0) {
        var currentUrl = window.location.href;
        var urlParts = currentUrl.split("/");
        var lastPart = urlParts[urlParts.length - 1];
        if (lastPart == "ultimate-subscription-plan" || lastPart == "craft-your-life-project-kit-monthly-subscription-plan" || lastPart == "build-a-garden-monthly-subscription-plan" || lastPart == "craft-a-flower-monthly-subscription-plan" || lastPart == "mini-delight-monthly-subscription" || lastPart == "dynamic-duo-subscription-plan" || lastPart == "stencil-art-bi-monthly-subscription-plan" || lastPart == "build-a-garden-monthly-subscription-plands") {
            $("header.section-header.section-header--404 img").attr("src", "https://cdn.shopify.com/s/files/1/0388/7541/files/Subscription-404-page-graphics-latest.jpg?v=1715053152");
        }
    }

    if (window.location.href.indexOf("https://altenew.com/pages/search-results-page?q") > -1) {
        setTimeout(function () {
            $('#snize-search-results-grid-mode ul li').each(function () {
                if ($(this).hasClass("snize-product-tag-complete_bundle_enabled_only")) {
                    $(this).find(".snize-option-selector-wrapper select").each(function () {
                        $(this).find('option').each(function (index) {
                            if (index !== 0) {
                                $(this).attr('disabled', 'disabled');
                            }
                        });
                    });
                }
            });
        }, 5000);
    }

    $(".project_photo_count").click(function () {
        $('html, body').animate({
            scrollTop: $("#project_photo_how_to").offset().top - 120
        }, 1000); // The number 1000 represents the duration of the animation in milliseconds
    });

    $('#CurrencyList-footer a[data-value="US"]').closest('li').prependTo('#CurrencyList-footer');
});


//Courses list page 2-27-2024
document.addEventListener('onCoursesRendered', () => {
    if (document.querySelector('.coursesSearchElement')) {
        document.querySelector('.coursesSearchElement').placeholder = 'Find your classes';
    }
    var sortedArray = Object.entries(productsBlock).sort((a, b) => {
        return (a[1].newest_ordertime < b[1].newest_ordertime) ? 1 : -1;
    })
    sortedArray.map((element, i) => {
        if (document.querySelector('.courseBlock:has(button[data-prod-id="' + element[0] + '"])')) {
            document.querySelector('.courseBlock:has(button[data-prod-id="' + element[0] + '"])').setAttribute('data-attr-order', i);
        }
    })
    var indexes = document.querySelectorAll(".courseBlock[data-attr-order]");
    var indexesArray = Array.from(indexes);
    var sorted = indexesArray.sort(function comparator(a, b) {
        if (parseInt(a.dataset.attrOrder) < parseInt(b.dataset.attrOrder))
            return -1;
        if (parseInt(a.dataset.attrOrder) > parseInt(b.dataset.attrOrder))
            return 1;
        return 0;
    });
    sorted.forEach(e => document.querySelector(".appendWrapper.row").appendChild(e));
});

// Function to get a cookie by name
function getCookie(name) {
    let cookieArr = document.cookie.split(';');

    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split('=');

        if (name == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

/*Searchanise on key up for instant search widget 12-18-2024*/
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        $(document).on('Searchanise.AutocompleteUpdated', function (event, input, container) {
            $('#snize-instant-search-results ul li').each(function () {
                //const $button = $(this).find('.snize-button');
                const $labeltext = $(this).find('span.snize-pre-order');
                const $labeltextOOS = $(this).find('span.snize-out-of-stock');
                const $priceList = $(this).find('.snize-price-list');
                if ($(this).hasClass("snize-product-tag-register-cta")) {
                    $labeltext.text("Register");
                } else if ($(this).hasClass("snize-product-tag-join-waitlist-cta")) {
                    $labeltext.text("Join Waitlist");
                    $labeltextOOS.text("Join Waitlist");
                    $priceList.css("display", "none");
                }
            });
        });
    })(window.Searchanise.$);
});

/* Update the chat icon image */
var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) {
    window.addEventListener('gorgias-widget-loaded', function () {
        resolve();
    })
});

initGorgiasChatPromise.then(function () {
    var timer = setInterval(function () {
        var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
        if (!chatButtonHead?.children.length) {
            return;
        }
        clearInterval(timer);

        var chatButtonIframe = document.querySelector('#chat-button');
        if (chatButtonIframe) {
            chatButtonIframe.style.display = "none";
        }
        var myButton = document.createElement('img');
        myButton.style.cssText = ` 
            position: fixed; 
            right: 45px;
            bottom: 20px; 
            z-index: 3147483000; 
            width: 60px; 
            height: 60px; 
            border-radius: 10px; 
            cursor: pointer;
            `;
        myButton.src = 'https://cdn.shopify.com/s/files/1/0388/7541/files/Chat-Icon.png?v=1736438053';  // Replace with the path to your icon image
        myButton.alt = 'Chat Icon';  // Optional, for accessibility purposes

        // Add a class to the image
        myButton.classList.add('custom-chat-icon');

        // onClick, behave like a chat opener
        myButton.onclick = function () {
            if (GorgiasChat.isOpen()) {
                GorgiasChat.close();
            } else {
                GorgiasChat.open();
            }
        }
        document.body.appendChild(myButton);
    }, 50);
});

function checkAndClick() {
    var $button = $('[data-type="newsletter"] button');
    if (window.innerWidth <= 768) {
        $('.footer__newsletter-input').removeAttr('required');
        $button.trigger('click');

        $(".grid__item.footer__item--1494292487693").insertAfter(".grid__item.footer__item--aeaf4542-18cd-430d-a74e-8e205ebb48f1");
        $(".shipping-date-holder").insertAfter(".payment-buttons");/*Added this for shipping order date on mobile 2-18-2025*/
        $(".inventoryWrapper").insertAfter(".payment-buttons"); /*Added for the inventory count on mobile 2-19-2025*/
        $(".inventoryWrapper").css({'display': 'inline-block', 'width': '100%'}); /*Added for the inventory count on mobile 2-19-2025*/

        //Blog Menu
        $(".template-blog li.mobile-nav__item.appear-animation.appear-delay-7 .mobile-nav__toggle button, .template-article li.mobile-nav__item.appear-animation.appear-delay-7 .mobile-nav__toggle button").click();
        $(".template-blog div#Linklist-https-altenew-com-blogs-paper-crafting-inspiration-and-tips6, .template-article div#Linklist-https-altenew-com-blogs-paper-crafting-inspiration-and-tips6").css("height", "165px");
    }
}

// Inject global lock styles for the cursor
if (!document.getElementById('wishlist-lock-styles')) {
    const style = document.createElement('style');
    style.id = 'wishlist-lock-styles';
    style.innerHTML = `
    .wishlist-loading .wishlist-engine,
    .wishlist-loading .wishlist-engine-button,
    .wishlist-loading [class*="wishlist-engine"] {
      cursor: progress !important;
    }
  `;
    document.head.appendChild(style);
}

document.addEventListener('click', (e) => {
    const wishlistEngine = e.target.closest('.wishlist-engine');
    if (!wishlistEngine) return;

    // Find a persistent parent element that won't be destroyed when the wishlist app re-renders the button
    const persistentParent = wishlistEngine.closest('.grid-product__content') ||
        wishlistEngine.closest('.product-single__meta') ||
        wishlistEngine.closest('form') ||
        wishlistEngine;

    // If the parent is currently throttled/locked, discard the click to prevent actions or card redirects
    if (persistentParent.classList.contains('wishlist-loading')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
    }

    const productId = wishlistEngine.getAttribute('data-product_id');
    const matchingButtons = productId
        ? document.querySelectorAll(`.wishlist-engine[data-product_id="${productId}"]`)
        : [wishlistEngine];

    // Lock the persistent parents of all matching instances on the page
    const lockedParents = [];
    matchingButtons.forEach(btn => {
        const parent = btn.closest('.grid-product__content') ||
            btn.closest('.product-single__meta') ||
            btn.closest('form') ||
            btn;
        parent.classList.add('wishlist-loading');
        lockedParents.push(parent);
    });

    // Release the lock after 1.2 seconds, allowing subsequent user clicks
    setTimeout(() => {
        lockedParents.forEach(parent => {
            parent.classList.remove('wishlist-loading');
        });
    }, 1200);
}, true); // Capturing phase to run before third-party handlers

/* =========================================================================
   Buy Now Redirection Interceptor
   Capture phase so it runs before every other ATC handler (theme AJAX,
   Rebuy Smart Cart, hc-form). Buy Now skips AJAX entirely: a native form
   POST to /cart/add with return_to=/checkout makes Shopify add the item
   and 302 straight to checkout — no Smart Cart drawer, no loading-state
   restyling of the button.
   ========================================================================= */
// Inject global lock styles for the Buy Now cursor
if (!document.getElementById('buy-now-lock-styles')) {
    const style = document.createElement('style');
    style.id = 'buy-now-lock-styles';
    style.innerHTML = `
    body.buy-now-submitting,
    body.buy-now-submitting *,
    body.buy-now-submitting button,
    body.buy-now-submitting input {
      cursor: progress !important;
    }
  `;
    document.head.appendChild(style);
}

document.addEventListener('click', function (e) {
    var trigger = e.target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], form[action*="/cart/add"] button[name="add"], .add-to-cart, .add-btn, .sticky-atb__btn');
    if (!trigger || trigger.disabled) return;

    var form = trigger.closest('form');
    if (!form) return;

    var buttonText = (trigger.textContent || trigger.value || '').trim().toLowerCase();
    var buyNowFlag = form.querySelector('.IsBuyNow');
    var isBuyNow = form.querySelector('input[name="return_to"][value="/checkout"]') !== null ||
        form.querySelector('.IsBuyNowInput') !== null ||
        (buyNowFlag && buyNowFlag.value === 'true') ||
        buttonText === 'buy now';

    if (!isBuyNow) return;

    e.preventDefault();
    e.stopPropagation();

    // Prevent double submission
    if (form.getAttribute('data-buy-now-submitting') === 'true') return;
    form.setAttribute('data-buy-now-submitting', 'true');

    // Change cursor to progress, and disable the button
    document.body.classList.add('buy-now-submitting');
    trigger.disabled = true;

    // Safety fallback: Re-enable after 10 seconds in case redirect/navigation fails
    setTimeout(function () {
        form.removeAttribute('data-buy-now-submitting');
        trigger.disabled = false;
        document.body.classList.remove('buy-now-submitting');
    }, 10000);

    if (!form.querySelector('input[name="return_to"]')) {
        var returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        returnTo.value = '/checkout';
        form.appendChild(returnTo);
    }

    // Native submit bypasses all JS submit handlers (theme AjaxProduct,
    // product-form custom element), so nothing intercepts the navigation.
    // That also bypasses the check before checkout in cart-actions.js, so run
    // it first: it takes out ended offers and dead codes already in the bag,
    // and never holds Buy Now for more than a few seconds.
    var check = window.AltenewCart && window.AltenewCart.beforeCheckout
        ? window.AltenewCart.beforeCheckout()
        : Promise.resolve();
    check.then(function () { form.submit(); }, function () { form.submit(); });
}, true);

// Re-enable Buy Now buttons and reset cursor when returning to page via history (bfcache)
window.addEventListener('pageshow', function (evt) {
    document.body.classList.remove('buy-now-submitting');
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (form.getAttribute('data-buy-now-submitting') === 'true') {
            form.removeAttribute('data-buy-now-submitting');
            var buttons = form.querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"], .add-to-cart, .add-btn, .sticky-atb__btn');
            buttons.forEach(function (btn) {
                btn.disabled = false;
            });
        }
    });
});

/* 07072026-001 / 07082026-001 Line up the "Add To Bag" / "View Options" buttons per ROW.
   Card content above the button varies in height between products in the same row:
     - the review badge wraps to 1 or 2 lines (e.g. "3 reviews" vs "128 reviews"), or is absent,
     - the price block is 1 or 2 lines (a sale/savings badge adds a line),
     - a longer compare-at price wraps to its own line.
   Any of these pushes a card's button down, breaking row alignment. Instead of guessing which
   element differs, we measure each card's real button offset, find the row's lowest button, and
   pad the price block so every button in the row lands there. Rows with no extra content keep
   their natural height (no wasted space); only cards that sit higher get padded down to match.
   Runs on the collection grid AND on best-sellers swipers (all visible slides share one row),
   each scoped to its own container so a grid and a carousel on the same page never mix rows. */
(function () {
    // .retired-card-spacer: a retired card has no price, so its empty stand-in takes the padding (14zcqnthubz).
    var PRICE_SEL = '.product__details > .grid-product__price:not(.grid-product__title):not(.default), .product__details > .retired-card-spacer';
    var CTA_SEL = '.add-to-cart__button, .hc-subscribe-redirect, #homepage-out-of-stock, .klaviyo-button-container, .retired-card-cta';

    // Top-most visible CTA within a card, relative to the viewport.
    function ctaTop(card) {
        var els = card.querySelectorAll(CTA_SEL), min = Infinity;
        els.forEach(function (e) {
            if (e.offsetParent !== null) {
                var t = e.getBoundingClientRect().top;
                if (t < min) { min = t; }
            }
        });
        return min === Infinity ? null : min;
    }

    // Pad each card's price block so its button reaches its row's lowest button, within one root.
    function equalize(root) {
        var cards = Array.prototype.slice.call(root.querySelectorAll('.grid-product'));
        if (!cards.length) return;

        // Clear previous padding so we measure natural offsets.
        var priceOf = new Map();
        cards.forEach(function (c) {
            var p = c.querySelector(PRICE_SEL);
            priceOf.set(c, p);
            if (p) { p.style.minHeight = ''; }
        });

        // Group cards into rows by their vertical position (swiper slides all share one row).
        var rows = [];
        cards.forEach(function (c) {
            var top = c.getBoundingClientRect().top;
            var row = null;
            for (var i = 0; i < rows.length; i++) {
                if (Math.abs(rows[i].top - top) < 5) { row = rows[i]; break; }
            }
            if (!row) { row = { top: top, items: [] }; rows.push(row); }
            row.items.push(c);
        });

        // For each row: pad each card's price block so its button reaches the row's lowest button.
        rows.forEach(function (row) {
            var data = row.items.map(function (c) {
                var p = priceOf.get(c);
                var cta = ctaTop(c);
                if (!p || cta == null) { return null; }
                return { price: p, offset: cta - c.getBoundingClientRect().top, height: p.offsetHeight };
            }).filter(Boolean);
            if (data.length < 2) { return; }

            var maxOffset = data.reduce(function (m, d) { return Math.max(m, d.offset); }, 0);
            data.forEach(function (d) {
                d.price.style.minHeight = (d.height + (maxOffset - d.offset)) + 'px';
            });
        });
    }

    // Containers to equalize: EVERY container that groups product cards into rows, on any
    // template — collection & search grids, homepage featured collections, related-product and
    // recently-viewed grids, and best-seller swipers (all visible slides share one visual row).
    // Keyed on the .grid-product cards themselves, not on a wrapper class, so any layout that
    // renders product cards is covered automatically (this is why the homepage featured grid
    // used to slip through — it's template-index and not a swiper, so the old template-collection
    // gate skipped it). Each card's row grouping still happens per-root inside equalize().
    function collectRoots() {
        var roots = new Set();
        document.querySelectorAll('.grid-product').forEach(function (card) {
            // In a swiper the card is nested in .swiper-slide — group by the wrapper so all
            // slides share one row. Elsewhere the card's direct grid container is the root.
            var slide = card.closest('.swiper-slide');
            var root = slide ? slide.closest('.swiper-wrapper') : card.parentElement;
            if (root) { roots.add(root); }
        });
        return Array.from(roots);
    }

    var targets = collectRoots();
    if (!targets.length) return;

    // Re-collect on each pass so grids/swipers that mount after init (recently-viewed from
    // localStorage, late-initialised carousels, paginated results) are picked up on the next
    // load / resize / mutation tick, not just the ones present at first run.
    function runAll() { collectRoots().forEach(equalize); }

    var debounce;
    function schedule() {
        clearTimeout(debounce);
        debounce = setTimeout(runAll, 120);
    }

    runAll();                            // script is deferred, so DOM is ready
    window.addEventListener('load', runAll); // re-run after images settle
    window.addEventListener('resize', schedule); // re-group when columns / slides-per-view change

    // Judge.me review badges inject asynchronously, and Swiper clones slides / re-lays them out
    // after init, all of which change card heights and grouping. So re-run when a container's
    // contents change. We watch node/text changes only, never attributes, so our own min-height
    // writes (and Swiper's inline transforms) don't retrigger the observer.
    if ('MutationObserver' in window) {
        targets.forEach(function (root) {
            new MutationObserver(schedule).observe(root, {
                childList: true,
                subtree: true,
                characterData: true
            });
        });
    }
})();

